import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: start;
    align-items: center;
    margin-left: ${({ longname }) => longname ? '4vw' : '12vw'};
    padding: .1rem;
    gap: 1.5rem;

    @media (max-width: 1260px)  {
        margin-left: ${({ longname }) => longname ? '2vw' : '8vw'};
    }

    @media (max-width: 1200px)  {
        margin-left: ${({ longname }) => longname ? '0vw' : '2vw'};
    }

    > div:nth-child(1){
        width: 3.33rem;
        height: 3.33rem;
        overflow: hidden;
        border-radius: 50%;
        background-color: #ffffff;
        flex-shrink: 0;
        > img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    > div:nth-child(2){
        display: flex;
        justify-content: center;
        flex-direction: column;
        > span:nth-child(1){
            font-size: ${({ longname }) => longname ? '0.9rem' : '1.25rem'};
            font-weight: 700;
        }
        > span:nth-child(2){
            color: #6c757d;
        }
    }
`;